var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 8.15625V9.66667M17.2188 9.66667V23.2604H24.4688M17.2188 9.66667H20.8438C22.8458 9.66667 24.4688 11.2896 24.4688 13.2917V23.2604M24.4688 23.2604H26.8854",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53385 23.2604H17.2214H4.53385ZM4.53385 23.2604V8.15625C4.53385 6.15422 6.15683 4.53125 8.15885 4.53125H13.5964C15.5984 4.53125 17.2214 6.15422 17.2214 8.15625V23.2604M4.53385 23.2604H2.11719H4.53385ZM12.388 10.5729H9.36719H12.388ZM9.36719 15.4062H12.388H9.36719Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53385 23.2604H17.2214V8.15625C17.2214 6.15422 15.5984 4.53125 13.5964 4.53125H8.15885C6.15683 4.53125 4.53385 6.15422 4.53385 8.15625V23.2604ZM4.53385 23.2604H2.11719M12.388 10.5729H9.36719M9.36719 15.4062H12.388",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.6e71745cf777b7bcf3684b605162a373.svg";
export { ForwardRef as ReactComponent };